var animations = {};
var events = {};

$(document).ready(function() {

  var $page = $(this);
  var $header = $page.find('header');
  var $content = $page.find('.content');
  var $footer = $page.find('footer');

  var $slogan = $header.find('.slogan');
  var $signature = $header.find('.signature');
  var $headerLogo = $header.find('.header-logo');
  var $headerTitle = $header.find('.header-title');
  var $headerPageTitle = $header.find('.header-page-title');

  var $homeLogo = $content.find('.logo');
  var $kid = $content.find('.child');
  var $kidImg = $kid.find('.kid');
  var $kidImgBlue = $kid.find('.kid-blue');
  var $navigator = $content.find('.navigator');
  var $navigatorItems = $navigator.find('.navigator-item');
  var $backBtn = $('.back-btn');
  var $discoverBtn = $('.cta.discover');
  var $shareBar = $('.shareBar');

  var mapLegendY = mapLegendPosition();

  var tl_home = null;
  var tl_nav = null;
  var tl_page = null;

  function mapLegendPosition() {

    var posY = 50;

    if ($(window).width() < 769) {
      posY = 70;
    }
    if ($(window).width() < 463) {
      posY = 90;
    }

    return posY;
  }

  var $alliFrames = $("iframe");
  $alliFrames.each(function() {

    var $iframe = $(this);

    $iframe.data('aspectRatio', this.height / this.width)
      .removeAttr('height')
      .removeAttr('width');

  });

  $(document).on('click', '.scrollanchor', function(e) {

    e.preventDefault();

    var dest = $(this).data('href');
    var rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
    var posY = $(dest).offset().top - $header.height() - (2 * rem);

    TweenLite.to(window, 1, {
      scrollTo: {
        y: posY
      },
      ease: Power2.easeOut
    });
  });

  animations.init = function() {

    $page.scrollTop(0);

    TweenMax.set($headerLogo, {
      autoAlpha: 0,
      display: 'none'
    });
    TweenMax.set($headerTitle, {
      autoAlpha: 0,
      display: 'none'
    });
    TweenMax.set($homeLogo, {
      autoAlpha: 1,
      display: 'block'
    });
    TweenMax.set($navigatorItems, {
      xPercent: -150
    });
    TweenMax.set($slogan, {
      xPercent: -100
    });
    TweenMax.set($signature, {
      xPercent: 200
    });
    TweenMax.set($discoverBtn, {
      autoAlpha: 0
    });
    TweenMax.set($('.page'), {
      autoAlpha: 0
    });
    TweenMax.set($kidImg, {
      autoAlpha: 1
    });
    TweenMax.set($kidImgBlue, {
      autoAlpha: 1
    });
    TweenMax.set($shareBar, {
      autoAlpha: 0,
      display: 'none'
    });
  };

  animations.home = function() {

    var tl = new TimelineMax({
      onComplete: events.home
    });

    tl.addLabel("start")
      .to($header, 1, {
        opacity: 1
      })
      .to($slogan, 1, {
        xPercent: 0,
        ease: Power4.easeOut
      }, "-=1")
      .to($signature, 1, {
        xPercent: 0,
        ease: Power4.easeOut
      }, "-=1")
      .addLabel("kid")
      .to($kidImg, 2, {
        autoAlpha: 1
      }, 1)
      .to($kidImgBlue, 2, {
        autoAlpha: 0
      }, 1)
      .to($discoverBtn, 0.25, {
        autoAlpha: 1
      }, "-=0.5");

    return (tl);
  };

  animations.navigation = function() {

    var tl = new TimelineMax({
      onComplete: events.navigation,
      onStart: events.initNavigation
    });

    tl.to($homeLogo, 0.3, {
        autoAlpha: 0,
        display: 'none'
      })
      .to($discoverBtn, 0.3, {
        autoAlpha: 0,
        display: 'none'
      }, "-=0.3")
      .to($slogan, .5, {
        autoAlpha: 0,
        display: 'none'
      }, "-=0.3")
      .to($signature, .5, {
        autoAlpha: 0,
        display: 'none'
      }, "-=.5")
      .set($header, {
        className: "inner"
      })
      .set($content, {
        className: "+=inner"
      })
      .to($headerLogo, 0.3, {
        autoAlpha: 1,
        display: 'inline-block'
      }, "+=.5")
      .to($headerTitle, 0.3, {
        autoAlpha: 1,
        display: 'block'
      }, "-=0.3")
      .addLabel('beforekid')
      .to($kid, 1, {
        xPercent: "+=15"
      }, "-=0.3")
      .addLabel('simple')
      .set($navigator, {
        display: 'inline-block'
      }, "-=1")
      .staggerTo($navigatorItems, .75, {
        xPercent: 0,
      }, 0.1, "-=1")
      .set($footer, {
        className: "inner"
      });

    if ($(window).width() < 768) {
      tl.to($kidImg, 2, {
          autoAlpha: 0
        }, 1)
        .to($kidImgBlue, 2, {
          autoAlpha: 1
        }, 1);
    }

    return (tl);
  };

  animations.page = function(id) {

    var $current_page = $('#' + id);
    var pageTitle = $current_page.data('pagetitle');

    $headerPageTitle.find('h1').text(pageTitle);

    var tl = new TimelineMax({
      onComplete: events.page,
      onCompleteParams: [id],
      onStart: events.initPage,
      onStartParams: [id],
      onReverseComplete: events.pageReverse,
      onReverseCompleteParams: [id]
    });

    tl.staggerTo($navigatorItems, .5, {
        xPercent: -150,
      }, 0.1)
      .set($navigator, {
        display: 'none'
      })
      .addLabel("page")
      .to($kidImg, 1, {
        autoAlpha: 0
      }, 0)
      .to($kidImgBlue, 1, {
        autoAlpha: 1
      }, 0)
      .set($header, {
        className: "inner fixed"
      })
      .set($content, {
        className: "+=elastic-header"
      })
      .set($footer, {
        className: "+=footer-page"
      })
      .to($current_page, .25, {
        autoAlpha: 1,
        display: 'block'
      })
      .to($shareBar, .25, {
        autoAlpha: 1,
        display: 'block'
      }, "-=0.25")
      .to($backBtn, .25, {
        autoAlpha: 1,
        display: 'inline-block'
      }, "-=0.25")
      .to($headerTitle, .25, {
        autoAlpha: 0,
        display: 'none'
      }, "-=0.25")
      .to($headerPageTitle, .25, {
        autoAlpha: 1,
        display: 'block'
      })
      .set($('body'), {
        'overflow-y': 'auto'
      })
      .addLabel("endPage");

    return (tl);
  };

  animations.pageToHome = function(id) {

    var $current_page = $('#' + id);

    $current_page.find('video').each(function() {
      var video = $(this)[0];
      video.pause();
    });

    var tl = new TimelineMax({
      onComplete: events.pageToHome,
      onCompleteParams: [id],
      onStart: events.initPageToHome,
      onStartParams: [id]
    });

    tl.add(tl_page.tweenFromTo("endPage", "page"));
    tl.add(function() {
      $footer.removeClass('footer-page');
    });
    tl.timeScale(2);
    tl.add(tl_nav.reverse(tl_nav.getLabelTime("beforekid")));
    //tl_nav.reverse("beforekid");
  };

  animations.pageToPage = function(fromId, toId) {

    var $current_page = $('#' + fromId);
    var $next_page = $('#' + toId);
    var pageTitle = $next_page.data('pagetitle');
    var $embedIFrames = $next_page.find("iframe");

    TweenMax.to($current_page, .25, {
      autoAlpha: 0,
      display: 'none'
    });

    $headerPageTitle.find('h1').text(pageTitle);

    TweenMax.to($next_page, .25, {
      autoAlpha: 1,
      display: 'block',
      onComplete: events.initPageToPage,
      onCompleteParams: [toId]
    });

    $page.scrollTop(0);

    $backBtn.on('click', function(e) {
      $next_page.find('video').each(function() {
        var video = $(this)[0];
        video.pause();
      });

      $embedIFrames.each(function(index, element) {
        $(this).removeAttr("src");
      });

      TweenMax.to($('.page'), .5, {
        autoAlpha: 0,
        display: 'none'
      });
    });

    $('.header-logo a').on('click', function(e) {
      $next_page.find('video').each(function() {
        var video = $(this)[0];
        video.pause();
      });

      $embedIFrames.each(function(index, element) {
        $(this).removeAttr("src");
      });

      TweenMax.to($('.page'), .3, {
        autoAlpha: 0,
        display: 'none'
      });
    });

    // events.page(toId);
  };

  events.initPageToPage = function(id) {
    var $next_page = $('#' + id);
    var $embedIFrames = $next_page.find("iframe");

    $embedIFrames.each(function() {

      var $el = $(this);
      var elSrc = $el.data('src');
      var $fluidEl = $el.closest('.page-coverimage');
      var newWidth = $fluidEl.width();

      if (!$el.prop("src") || $el.prop("src") == "") {
        $el.prop("src", elSrc);
      }

      $el.width(newWidth)
        .height(newWidth * $el.data('aspectRatio'));
    });
  };

  events.init = function() {
    $discoverBtn.off('click').on('click', function(e) {
      e.preventDefault();
    });
  };

  events.home = function() {
    $discoverBtn.off('click').on('click', function(e) {
      e.preventDefault();
      tl_nav = animations.navigation();
    });
  };

  events.initNavigation = function() {
    $('.header-logo a').off('click');
  };

  events.navigation = function() {

    $('.header-logo a').off('click').on('click', function(e) {
      e.preventDefault();

      $(this).off('click');

      tl_nav.reverse();
    });

    $navigatorItems.off('click').on('click', function(e) {
      e.preventDefault();

      $navigatorItems.off('click');

      var pageId = $(this).data('page');

      tl_page = animations.page(pageId);

    });
  };

  events.page = function(id) {

    var $current_page = $('#' + id);
    var $chartContainer = $current_page.find('#container');
    var $embedIFrames = $current_page.find("iframe");

    if ($chartContainer.length) {
      $chartContainer.highcharts().reflow();
    }

    $backBtn.off('click').on('click', function(e) {
      e.preventDefault();

      $current_page.find('video').each(function() {
        var video = $(this)[0];
        video.pause();
      });

      $embedIFrames.each(function(index, element) {
        $(this).removeAttr("src");
      });

      $(this).off('click');
      $('.header-logo a').off('click');

      $navigatorItems.off('click');

      setTimeout(function() {
        $content.removeClass('elastic-header');
        $page.scrollTop(0);
      }, 500);

      tl_page.reverse();
    });

    $('.header-logo a').off('click').on('click', function(e) {
      e.preventDefault();

      $current_page.find('video').each(function() {
        var video = $(this)[0];
        video.pause();
      });

      $embedIFrames.each(function(index, element) {
        $(this).removeAttr("src");
      });

      $(this).off('click');
      $backBtn.off('click');

      animations.pageToHome(id);
    });

    $('.gotopage').off('click').on('click', function(e) {
      e.preventDefault();

      $current_page.find('video').each(function() {
        var video = $(this)[0];
        video.pause();
      });

      var toId = $(this).data('page');
      animations.pageToPage(id, toId);
    });

    $(window).resize(function() {

      // Resize all videos according to their own aspect ratio
      $embedIFrames.each(function() {

        var $el = $(this);
        var elSrc = $el.data('src');
        var $fluidEl = $el.closest('.page-coverimage');
        var newWidth = $fluidEl.width();

        if (!$el.prop("src") || $el.prop("src") == "") {
          $el.prop("src", elSrc);
        }

        $el.width(newWidth)
          .height(newWidth * $el.data('aspectRatio'));
      });

      if ($chartContainer.length) {
        var chart = $chartContainer.highcharts();
        chart.legend.options.y = mapLegendPosition();
      }
    });

    $(window).trigger('resize');

    $(window).on('scroll', function() {

      if ($page.scrollTop() > 0) {
        TweenMax.set($header, {
          className: '+=small'
        });
      } else {
        TweenMax.set($header, {
          className: '-=small'
        });
      }
    });
  };

  events.initPage = function(id) {
    $page.scrollTop(0);
    $('.header-logo a').off('click');
  };

  events.pageReverse = function(id) {

    var $current_page = $('#' + id);

    $current_page.find('video').each(function() {
      var video = $(this)[0];
      video.load();
    });

    $navigatorItems.off('click').on('click', function(e) {
      e.preventDefault();

      $navigatorItems.off('click');

      var pageId = $(this).data('page');

      tl_page = animations.page(pageId);

    });

    $('.header-logo a').off('click').on('click', function(e) {
      e.preventDefault();

      $(this).off('click');

      tl_nav.reverse();
    });

    $(window).off('scroll');

  };

  events.initPageToHome = function(id) {

    var $current_page = $('#' + id);

    setTimeout(function() {
      $content.removeClass('elastic-header');
      $page.scrollTop(0);
    }, 500);

    $backBtn.off('click');
  };

  events.pageToHome = function(id) {

    $header.removeClass('inner');
    $navigator.css({
      display: 'none'
    });

    var $current_page = $('#' + id);

    $current_page.find('video').each(function() {
      var video = $(this)[0];
      video.load();
    });

    TweenMax.to($kidImg, .5, {
      autoAlpha: 1
    });
    TweenMax.to($kidImgBlue, .5, {
      autoAlpha: 0
    });

    $(window).off('scroll');
  };

  events.init();
  animations.init();

  $('#container').highcharts('Map', {

    chart: {
      backgroundColor: {
        linearGradient: {
          x1: 0,
          y1: 0,
          x2: 1,
          y2: 1
        },
        stops: [
          [0, '#091e3d'],
          [1, '#1679b4']
        ]
      },
      borderWidth: 1,
      borderColor: "#000000",

    },

    legend: {
      align: 'center',
      verticalAlign: 'top',
      y: mapLegendY,
      floating: true,
      layout: 'horizontal',
      valueDecimals: 0,
      backgroundColor: (Highcharts.theme && Highcharts.theme.legendBackgroundColor) || 'rgba(255, 255, 255, 0.85)',
      symbolRadius: 0,
      symbolHeight: 14
    },

    title: {
      text: '<br />World Food Programme Cash-based Transfer (CBT) Financial Service Providers (FSPs)<br />',
      style: {
        color: '#FFFFFF',
        font: '16px Lucida Grande, Lucida Sans Unicode, Verdana, Arial, Helvetica, sans-serif',
        height: 400,
        verticalAlign: 'middle'
      }
    },

    mapNavigation: {
      enabled: true,
      buttonOptions: {
        verticalAlign: 'bottom'
      },
      enableMouseWheelZoom: $(window).width() <= 1024
    },

    tooltip: {
      backgroundColor: 'none',
      borderWidth: 0,
      shadow: false,
      useHTML: true,
      padding: 0,
      pointFormat: //'<span class="f32"><span class="flag {point.flag}"></span></span>' +
        '<b>{point.name}</b>' +
        //'<br>CBT BEN 2014: {point.CBT_BEN_2014}' +
        //'<br>CBT PLAN BUDGET: {point.CBT_PLAN_BUDGET}' +
        //'<br>Value: {point.value}' +
        '<br>{point.FSPs}'
    },

    colorAxis: {
      dataClasses: [{
        from: 30,
        to: 30,
        color: '#cccc33',
        name: 'L.America & Carribean'
      }, {
        from: 60,
        to: 60,
        color: '#993366',
        name: 'West Africa'
      }, {
        from: 20,
        to: 20,
        color: '#009933',
        name: 'East Africa'
      }, {
        from: 50,
        to: 50,
        color: '#3399cc',
        name: 'South Africa'
      }, {
        from: 40,
        to: 40,
        color: '#ff3333',
        name: 'MENA & E. Europe'
      }, {
        to: 10,
        color: '#ff9933',
        name: 'Asia'
      }]
    },

    xAxis: {
      minRange: 2000 // <- prevent zooming in too much
    },

    series: [{
      name: 'Countries',
      mapData: Highcharts.maps['custom/world'],
      color: '#E0E0E0',
      enableMouseTracking: false
    }, {
      name: 'FSPs',
      mapData: Highcharts.maps['custom/world'],
      data: [{
        "value": 10,
        "ISO2": "AF",
        "Country": "Afghanistan",
        "CBT_BEN_2014": 192213,
        "CBT_PLAN_BUDGET": 6759344.31,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 40,
        "ISO2": "DZ",
        "Country": "Algeria",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 40,
        "ISO2": "AM",
        "Country": "Armenia",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": null,
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>"
      }, {
        "value": 10,
        "ISO2": "BD",
        "Country": "Bangladesh",
        "CBT_BEN_2014": 172317,
        "CBT_PLAN_BUDGET": 7027949,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": "FSP5: Mobile money",
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP5: Mobile money<br>FSP6: Remittance<br>"
      }, {
        "value": 60,
        "ISO2": "BJ",
        "Country": "Benin",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 10,
        "ISO2": "BT",
        "Country": "Bhutan",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 30,
        "ISO2": "BO",
        "Country": "Bolivia",
        "CBT_BEN_2014": 7606,
        "CBT_PLAN_BUDGET": 431340,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 60,
        "ISO2": "BF",
        "Country": "Burkina Faso",
        "CBT_BEN_2014": 177485,
        "CBT_PLAN_BUDGET": 15991434,
        "FSP1": "FSP1: Mobile Money",
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP1: Mobile Money<br>FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 20,
        "ISO2": "BI",
        "Country": "Burundi",
        "CBT_BEN_2014": 135343,
        "CBT_PLAN_BUDGET": 8076607.48,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 10,
        "ISO2": "KH",
        "Country": "Cambodia",
        "CBT_BEN_2014": 48615,
        "CBT_PLAN_BUDGET": 1063260,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 60,
        "ISO2": "CM",
        "Country": "Cameroon",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": "FSP3: Pre-paid cards",
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP3: Pre-paid cards<br>FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 60,
        "ISO2": "CV",
        "Country": "Cape Verde",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 60,
        "ISO2": "CF",
        "Country": "Cetral African Republic",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 60,
        "ISO2": "TD",
        "Country": "Chad",
        "CBT_BEN_2014": 241725,
        "CBT_PLAN_BUDGET": 22187965.2,
        "FSP1": "FSP1: Mobile Money",
        "FSP2": null,
        "FSP3": "FSP3: Pre-paid cards",
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP1: Mobile Money<br>FSP3: Pre-paid cards<br>FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 30,
        "ISO2": "CO",
        "Country": "Colombia",
        "CBT_BEN_2014": 19354,
        "CBT_PLAN_BUDGET": 1023211,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 50,
        "ISO2": "CD",
        "Country": "Congo, Democratic Republic of",
        "CBT_BEN_2014": 40513,
        "CBT_PLAN_BUDGET": 16282745,
        "FSP1": "FSP1: Mobile Money",
        "FSP2": null,
        "FSP3": "FSP3: Mobile money",
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": "FSP6: Mobile Money",
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP1: Mobile Money<br>FSP3: Mobile money<br>FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Mobile Money<br>FSP6: Remittance<br>"
      }, {
        "value": 50,
        "ISO2": "CG",
        "Country": "Congo, Republic of",
        "CBT_BEN_2014": 5206,
        "CBT_PLAN_BUDGET": 6181186,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 60,
        "ISO2": "CI",
        "Country": "C\u00f4te D'Ivoire",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 6957079,
        "FSP1": null,
        "FSP2": null,
        "FSP3": "FSP3: Pre-paid cards",
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP3: Pre-paid cards<br>FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 30,
        "ISO2": "CU",
        "Country": "Cuba",
        "CBT_BEN_2014": 389125,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": null,
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>"
      }, {
        "value": 20,
        "ISO2": "DJ",
        "Country": "Djibouti",
        "CBT_BEN_2014": 34750,
        "CBT_PLAN_BUDGET": 1263203,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 10,
        "ISO2": "DM",
        "Country": "DPR Korea",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": null,
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>"
      }, {
        "value": 30,
        "ISO2": "EC",
        "Country": "Ecuador",
        "CBT_BEN_2014": 34991,
        "CBT_PLAN_BUDGET": 2164651,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 40,
        "ISO2": "EG",
        "Country": "Egypt",
        "CBT_BEN_2014": 100189,
        "CBT_PLAN_BUDGET": 49482388.7,
        "FSP1": null,
        "FSP2": "FSP2: Pre-paid cards",
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": "FSP6: Mobile Money",
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP2: Pre-paid cards<br>FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Mobile Money<br>FSP6: Remittance<br>"
      }, {
        "value": 30,
        "ISO2": "SV",
        "Country": "El Salvador",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 2426403.01,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 20,
        "ISO2": "ET",
        "Country": "Ethiopia",
        "CBT_BEN_2014": 339665,
        "CBT_PLAN_BUDGET": 30177390.7,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 60,
        "ISO2": "GM",
        "Country": "Gambia ",
        "CBT_BEN_2014": 11232,
        "CBT_PLAN_BUDGET": 1542522.05,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 60,
        "ISO2": "GH",
        "Country": "Ghana",
        "CBT_BEN_2014": 123861,
        "CBT_PLAN_BUDGET": 4463660.24,
        "FSP1": "FSP1: Mobile Money",
        "FSP2": "FSP2: Pre-paid cards",
        "FSP3": "FSP3: Pre-paid cards",
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": "FSP5: mobile money",
        "FSP6": null,
        "FSP7": "FSP6: Mobile Money",
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP1: Mobile Money<br>FSP2: Pre-paid cards<br>FSP3: Pre-paid cards<br>FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP5: mobile money<br>FSP6: Mobile Money<br>FSP6: Remittance<br>"
      }, {
        "value": 30,
        "ISO2": "GT",
        "Country": "Guatemala",
        "CBT_BEN_2014": 158480,
        "CBT_PLAN_BUDGET": 5035059,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 60,
        "ISO2": "GN",
        "Country": "Guinea",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 510300,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 60,
        "ISO2": "GW",
        "Country": "Guinea-Bissau",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 30,
        "ISO2": "HT",
        "Country": "Haiti",
        "CBT_BEN_2014": 74075,
        "CBT_PLAN_BUDGET": 9932045,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 30,
        "ISO2": "HN",
        "Country": "Honduras",
        "CBT_BEN_2014": 29855,
        "CBT_PLAN_BUDGET": 5245991.96,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 10,
        "ISO2": "IN",
        "Country": "India",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": "FSP2: Pre-paid cards",
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": "FSP6: Mobile Money",
        "FSP8": null,
        "FSP_Formula": "",
        "FSPs": "FSP2: Pre-paid cards<br>FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Mobile Money<br>"
      }, {
        "value": 10,
        "ISO2": "ID",
        "Country": "Indonesia",
        "CBT_BEN_2014": 8733,
        "CBT_PLAN_BUDGET": 119486,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": "FSP5: mobile money; pre-paid cards",
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP5: mobile money; pre-paid cards<br>FSP6: Remittance<br>"
      }, {
        "value": 40,
        "ISO2": "IR",
        "Country": "Iran",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": null,
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>"
      }, {
        "value": 40,
        "ISO2": "IQ",
        "Country": "Iraq",
        "CBT_BEN_2014": 325952,
        "CBT_PLAN_BUDGET": 81751385.7,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 40,
        "ISO2": "JO",
        "Country": "Jordan",
        "CBT_BEN_2014": 577702,
        "CBT_PLAN_BUDGET": 267613689,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 20,
        "ISO2": "KE",
        "Country": "Kenya",
        "CBT_BEN_2014": 454275,
        "CBT_PLAN_BUDGET": 33287363.6,
        "FSP1": "FSP1: Mobile Money",
        "FSP2": "FSP2: Mobile money, Pre-paid cards",
        "FSP3": "FSP3: Mobile money, Pre-paid cards.",
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": "FSP6: Mobile Money",
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP1: Mobile Money<br>FSP2: Mobile money, Pre-paid cards<br>FSP3: Mobile money, Pre-paid cards.<br>FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Mobile Money<br>FSP6: Remittance<br>"
      }, {
        "value": 40,
        "ISO2": "KG",
        "Country": "Kyrgystan",
        "CBT_BEN_2014": 19040,
        "CBT_PLAN_BUDGET": 668268,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 10,
        "ISO2": "LA",
        "Country": "Lao PDR",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 496141,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 40,
        "ISO2": "LB",
        "Country": "Lebanon",
        "CBT_BEN_2014": 908772,
        "CBT_PLAN_BUDGET": 393712888,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 50,
        "ISO2": "LS",
        "Country": "Lesotho",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": "FSP6: Mobile Money",
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Mobile Money<br>FSP6: Remittance<br>"
      }, {
        "value": 60,
        "ISO2": "LR",
        "Country": "Liberia",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 1710000,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 40,
        "ISO2": "LY",
        "Country": "Libya ",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 50,
        "ISO2": "MG",
        "Country": "Madagascar",
        "CBT_BEN_2014": 2490,
        "CBT_PLAN_BUDGET": 683929.95,
        "FSP1": "FSP1: Mobile Money",
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP1: Mobile Money<br>FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 50,
        "ISO2": "MW",
        "Country": "Malawi",
        "CBT_BEN_2014": 153560,
        "CBT_PLAN_BUDGET": 9342565,
        "FSP1": "FSP1: Mobile Money",
        "FSP2": null,
        "FSP3": "FSP3: Mobile money",
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP1: Mobile Money<br>FSP3: Mobile money<br>FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 60,
        "ISO2": "ML",
        "Country": "Mali",
        "CBT_BEN_2014": 253512,
        "CBT_PLAN_BUDGET": 48627398.1,
        "FSP1": null,
        "FSP2": null,
        "FSP3": "FSP3: pre-paid cards",
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP3: pre-paid cards<br>FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 60,
        "ISO2": "MR",
        "Country": "Mauritania",
        "CBT_BEN_2014": 72055,
        "CBT_PLAN_BUDGET": 12801296,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 50,
        "ISO2": "MZ",
        "Country": "Mozambique",
        "CBT_BEN_2014": 59051,
        "CBT_PLAN_BUDGET": 4320333,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": "FSP6: Mobile Money",
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Mobile Money<br>FSP6: Remittance<br>"
      }, {
        "value": 10,
        "ISO2": "MM",
        "Country": "Myanmar",
        "CBT_BEN_2014": 46650,
        "CBT_PLAN_BUDGET": 1073075,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 50,
        "ISO2": "NA",
        "Country": "Namibia",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": null,
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>"
      }, {
        "value": 10,
        "ISO2": "NP",
        "Country": "Nepal",
        "CBT_BEN_2014": 68646,
        "CBT_PLAN_BUDGET": 5660742,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 30,
        "ISO2": "NI",
        "Country": "Nicaragua",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 60,
        "ISO2": "NE",
        "Country": "Niger",
        "CBT_BEN_2014": 366528,
        "CBT_PLAN_BUDGET": 88108876.8,
        "FSP1": "FSP1: Mobile Money",
        "FSP2": null,
        "FSP3": "FSP3: pre-paid cards",
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP1: Mobile Money<br>FSP3: pre-paid cards<br>FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 10,
        "ISO2": "PK",
        "Country": "Pakistan",
        "CBT_BEN_2014": 196698,
        "CBT_PLAN_BUDGET": 14055321.8,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": "FSP5: mobile money; pre-paid cards",
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP5: mobile money; pre-paid cards<br>FSP6: Remittance<br>"
      }, {
        "value": 40,
        "ISO2": "PS",
        "Country": "Palestine ",
        "CBT_BEN_2014": 481631,
        "CBT_PLAN_BUDGET": 38411235,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 30,
        "ISO2": "PY",
        "Country": "Paraguay ",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 927557,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 10,
        "ISO2": "PH",
        "Country": "Philippines",
        "CBT_BEN_2014": 530990,
        "CBT_PLAN_BUDGET": 14381928,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": "FSP5: mobile money; pre-paid cards",
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP5: mobile money; pre-paid cards<br>FSP6: Remittance<br>"
      }, {
        "value": 20,
        "ISO2": "RW",
        "Country": "Rwanda",
        "CBT_BEN_2014": 15948,
        "CBT_PLAN_BUDGET": 3005400,
        "FSP1": "FSP1: Mobile Money",
        "FSP2": null,
        "FSP3": "FSP3: Mobile Money",
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP1: Mobile Money<br>FSP3: Mobile Money<br>FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 60,
        "ISO2": "ST",
        "Country": "S\u00e3o Tom\u00e9 and Principe",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 60,
        "ISO2": "SN",
        "Country": "Senegal",
        "CBT_BEN_2014": 211880,
        "CBT_PLAN_BUDGET": 6998774.02,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 60,
        "ISO2": "SL",
        "Country": "Sierra Leone",
        "CBT_BEN_2014": 1008,
        "CBT_PLAN_BUDGET": 476000,
        "FSP1": "FSP1: Mobile Money",
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP1: Mobile Money<br>FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 20,
        "ISO2": "SO",
        "Country": "Somalia",
        "CBT_BEN_2014": 60108,
        "CBT_PLAN_BUDGET": 19482889,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": null,
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>"
      }, {
        "value": 20,
        "ISO2": "SS",
        "Country": "South Sudan",
        "CBT_BEN_2014": 28770,
        "CBT_PLAN_BUDGET": 29321465.8,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": null,
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>"
      }, {
        "value": 10,
        "ISO2": "LK",
        "Country": "Sri Lanka",
        "CBT_BEN_2014": 62250,
        "CBT_PLAN_BUDGET": 3061013,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": null,
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>"
      }, {
        "value": 40,
        "ISO2": "SD",
        "Country": "Sudan",
        "CBT_BEN_2014": 539396,
        "CBT_PLAN_BUDGET": 40384945,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 50,
        "ISO2": "SZ",
        "Country": "Swaziland",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": null,
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>"
      }, {
        "value": 40,
        "ISO2": "SY",
        "Country": "Syria",
        "CBT_BEN_2014": 2957,
        "CBT_PLAN_BUDGET": 5512144,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": null,
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>"
      }, {
        "value": 40,
        "ISO2": "TJ",
        "Country": "Tajikistan",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": null,
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>"
      }, {
        "value": 50,
        "ISO2": "TZ",
        "Country": "Tanzania, United Republic of",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 47803.42,
        "FSP1": "FSP1: Mobile Money",
        "FSP2": "FSP2: Pre-paid cards",
        "FSP3": "FSP3: Mobile Money",
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": "FSP6: Mobile Money",
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP1: Mobile Money<br>FSP2: Pre-paid cards<br>FSP3: Mobile Money<br>FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Mobile Money<br>FSP6: Remittance<br>"
      }, {
        "value": 10,
        "ISO2": "TL",
        "Country": "Timor-Leste",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": null,
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>"
      }, {
        "value": 60,
        "ISO2": "TG",
        "Country": "Togo",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": "FSP3: Pre-paid Cards",
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP3: Pre-paid Cards<br>FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 40,
        "ISO2": "TN",
        "Country": "Tunisia",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 40,
        "ISO2": "TR",
        "Country": "Turkey ",
        "CBT_BEN_2014": 219813,
        "CBT_PLAN_BUDGET": 110613859,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 20,
        "ISO2": "UG",
        "Country": "Uganda",
        "CBT_BEN_2014": 6752,
        "CBT_PLAN_BUDGET": 2140109,
        "FSP1": "FSP1: Mobile Money",
        "FSP2": "FSP2: Mobile Money, Pre-paid cards",
        "FSP3": "FSP3: Mobile Money",
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP1: Mobile Money<br>FSP2: Mobile Money, Pre-paid cards<br>FSP3: Mobile Money<br>FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 40,
        "ISO2": "UA",
        "Country": "Ukraine ",
        "CBT_BEN_2014": 9712,
        "CBT_PLAN_BUDGET": 4565000,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 40,
        "ISO2": "YE",
        "Country": "Yemen",
        "CBT_BEN_2014": 547785,
        "CBT_PLAN_BUDGET": 28162285.7,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 50,
        "ISO2": "ZM",
        "Country": "Zambia",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 890000,
        "FSP1": "FSP1: Mobile Money",
        "FSP2": "FSP2: Pre-paid cards",
        "FSP3": "FSP3: Mobile money, Pre-paid cards.",
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": "FSP5: Mobile Money",
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP1: Mobile Money<br>FSP2: Pre-paid cards<br>FSP3: Mobile money, Pre-paid cards.<br>FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP5: Mobile Money<br>FSP6: Remittance<br>"
      }, {
        "value": 50,
        "ISO2": "ZW",
        "Country": "Zimbabwe",
        "CBT_BEN_2014": 334098,
        "CBT_PLAN_BUDGET": 18390900,
        "FSP1": null,
        "FSP2": "FSP2: Pre-paid cards",
        "FSP3": "FSP3: Pre-paid cards",
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP2: Pre-paid cards<br>FSP3: Pre-paid cards<br>FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }],
      allAreas: true,
      joinBy: ['iso-a2', 'ISO2'],
      states: {
        hover: {
          color: '#CDCDCD'
        }
      }
    }, {
      name: 'FSPs',
      type: 'mapbubble',
      data: [{
        "value": 10,
        "ISO2": "AF",
        "Country": "Afghanistan",
        "CBT_BEN_2014": 192213,
        "CBT_PLAN_BUDGET": 6759344.31,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 40,
        "ISO2": "DZ",
        "Country": "Algeria",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 40,
        "ISO2": "AM",
        "Country": "Armenia",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": null,
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>"
      }, {
        "value": 10,
        "ISO2": "BD",
        "Country": "Bangladesh",
        "CBT_BEN_2014": 172317,
        "CBT_PLAN_BUDGET": 7027949,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": "FSP5: Mobile money",
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP5: Mobile money<br>FSP6: Remittance<br>"
      }, {
        "value": 60,
        "ISO2": "BJ",
        "Country": "Benin",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 10,
        "ISO2": "BT",
        "Country": "Bhutan",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 30,
        "ISO2": "BO",
        "Country": "Bolivia",
        "CBT_BEN_2014": 7606,
        "CBT_PLAN_BUDGET": 431340,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 60,
        "ISO2": "BF",
        "Country": "Burkina Faso",
        "CBT_BEN_2014": 177485,
        "CBT_PLAN_BUDGET": 15991434,
        "FSP1": "FSP1: Mobile Money",
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP1: Mobile Money<br>FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 20,
        "ISO2": "BI",
        "Country": "Burundi",
        "CBT_BEN_2014": 135343,
        "CBT_PLAN_BUDGET": 8076607.48,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 10,
        "ISO2": "KH",
        "Country": "Cambodia",
        "CBT_BEN_2014": 48615,
        "CBT_PLAN_BUDGET": 1063260,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 60,
        "ISO2": "CM",
        "Country": "Cameroon",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": "FSP3: Pre-paid cards",
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP3: Pre-paid cards<br>FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 60,
        "ISO2": "CV",
        "Country": "Cape Verde",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 60,
        "ISO2": "CF",
        "Country": "Cetral African Republic",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 60,
        "ISO2": "TD",
        "Country": "Chad",
        "CBT_BEN_2014": 241725,
        "CBT_PLAN_BUDGET": 22187965.2,
        "FSP1": "FSP1: Mobile Money",
        "FSP2": null,
        "FSP3": "FSP3: Pre-paid cards",
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP1: Mobile Money<br>FSP3: Pre-paid cards<br>FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 30,
        "ISO2": "CO",
        "Country": "Colombia",
        "CBT_BEN_2014": 19354,
        "CBT_PLAN_BUDGET": 1023211,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 50,
        "ISO2": "CD",
        "Country": "Congo, Democratic Republic of",
        "CBT_BEN_2014": 40513,
        "CBT_PLAN_BUDGET": 16282745,
        "FSP1": "FSP1: Mobile Money",
        "FSP2": null,
        "FSP3": "FSP3: Mobile money",
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": "FSP6: Mobile Money",
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP1: Mobile Money<br>FSP3: Mobile money<br>FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Mobile Money<br>FSP6: Remittance<br>"
      }, {
        "value": 50,
        "ISO2": "CG",
        "Country": "Congo, Republic of",
        "CBT_BEN_2014": 5206,
        "CBT_PLAN_BUDGET": 6181186,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 60,
        "ISO2": "CI",
        "Country": "C\u00f4te D'Ivoire",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 6957079,
        "FSP1": null,
        "FSP2": null,
        "FSP3": "FSP3: Pre-paid cards",
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP3: Pre-paid cards<br>FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 30,
        "ISO2": "CU",
        "Country": "Cuba",
        "CBT_BEN_2014": 389125,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": null,
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>"
      }, {
        "value": 20,
        "ISO2": "DJ",
        "Country": "Djibouti",
        "CBT_BEN_2014": 34750,
        "CBT_PLAN_BUDGET": 1263203,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 10,
        "ISO2": "DM",
        "Country": "DPR Korea",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": null,
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>"
      }, {
        "value": 30,
        "ISO2": "EC",
        "Country": "Ecuador",
        "CBT_BEN_2014": 34991,
        "CBT_PLAN_BUDGET": 2164651,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 40,
        "ISO2": "EG",
        "Country": "Egypt",
        "CBT_BEN_2014": 100189,
        "CBT_PLAN_BUDGET": 49482388.7,
        "FSP1": null,
        "FSP2": "FSP2: Pre-paid cards",
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": "FSP6: Mobile Money",
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP2: Pre-paid cards<br>FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Mobile Money<br>FSP6: Remittance<br>"
      }, {
        "value": 30,
        "ISO2": "SV",
        "Country": "El Salvador",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 2426403.01,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 20,
        "ISO2": "ET",
        "Country": "Ethiopia",
        "CBT_BEN_2014": 339665,
        "CBT_PLAN_BUDGET": 30177390.7,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 60,
        "ISO2": "GM",
        "Country": "Gambia ",
        "CBT_BEN_2014": 11232,
        "CBT_PLAN_BUDGET": 1542522.05,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 60,
        "ISO2": "GH",
        "Country": "Ghana",
        "CBT_BEN_2014": 123861,
        "CBT_PLAN_BUDGET": 4463660.24,
        "FSP1": "FSP1: Mobile Money",
        "FSP2": "FSP2: Pre-paid cards",
        "FSP3": "FSP3: Pre-paid cards",
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": "FSP5: mobile money",
        "FSP6": null,
        "FSP7": "FSP6: Mobile Money",
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP1: Mobile Money<br>FSP2: Pre-paid cards<br>FSP3: Pre-paid cards<br>FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP5: mobile money<br>FSP6: Mobile Money<br>FSP6: Remittance<br>"
      }, {
        "value": 30,
        "ISO2": "GT",
        "Country": "Guatemala",
        "CBT_BEN_2014": 158480,
        "CBT_PLAN_BUDGET": 5035059,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 60,
        "ISO2": "GN",
        "Country": "Guinea",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 510300,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 60,
        "ISO2": "GW",
        "Country": "Guinea-Bissau",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 30,
        "ISO2": "HT",
        "Country": "Haiti",
        "CBT_BEN_2014": 74075,
        "CBT_PLAN_BUDGET": 9932045,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 30,
        "ISO2": "HN",
        "Country": "Honduras",
        "CBT_BEN_2014": 29855,
        "CBT_PLAN_BUDGET": 5245991.96,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 10,
        "ISO2": "IN",
        "Country": "India",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": "FSP2: Pre-paid cards",
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": "FSP6: Mobile Money",
        "FSP8": null,
        "FSP_Formula": "",
        "FSPs": "FSP2: Pre-paid cards<br>FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Mobile Money<br>"
      }, {
        "value": 10,
        "ISO2": "ID",
        "Country": "Indonesia",
        "CBT_BEN_2014": 8733,
        "CBT_PLAN_BUDGET": 119486,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": "FSP5: mobile money; pre-paid cards",
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP5: mobile money; pre-paid cards<br>FSP6: Remittance<br>"
      }, {
        "value": 40,
        "ISO2": "IR",
        "Country": "Iran",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": null,
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>"
      }, {
        "value": 40,
        "ISO2": "IQ",
        "Country": "Iraq",
        "CBT_BEN_2014": 325952,
        "CBT_PLAN_BUDGET": 81751385.7,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 40,
        "ISO2": "JO",
        "Country": "Jordan",
        "CBT_BEN_2014": 577702,
        "CBT_PLAN_BUDGET": 267613689,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 20,
        "ISO2": "KE",
        "Country": "Kenya",
        "CBT_BEN_2014": 454275,
        "CBT_PLAN_BUDGET": 33287363.6,
        "FSP1": "FSP1: Mobile Money",
        "FSP2": "FSP2: Mobile money, Pre-paid cards",
        "FSP3": "FSP3: Mobile money, Pre-paid cards.",
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": "FSP6: Mobile Money",
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP1: Mobile Money<br>FSP2: Mobile money, Pre-paid cards<br>FSP3: Mobile money, Pre-paid cards.<br>FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Mobile Money<br>FSP6: Remittance<br>"
      }, {
        "value": 40,
        "ISO2": "KG",
        "Country": "Kyrgystan",
        "CBT_BEN_2014": 19040,
        "CBT_PLAN_BUDGET": 668268,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 10,
        "ISO2": "LA",
        "Country": "Lao PDR",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 496141,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 40,
        "ISO2": "LB",
        "Country": "Lebanon",
        "CBT_BEN_2014": 908772,
        "CBT_PLAN_BUDGET": 393712888,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 50,
        "ISO2": "LS",
        "Country": "Lesotho",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": "FSP6: Mobile Money",
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Mobile Money<br>FSP6: Remittance<br>"
      }, {
        "value": 60,
        "ISO2": "LR",
        "Country": "Liberia",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 1710000,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 40,
        "ISO2": "LY",
        "Country": "Libya ",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 50,
        "ISO2": "MG",
        "Country": "Madagascar",
        "CBT_BEN_2014": 2490,
        "CBT_PLAN_BUDGET": 683929.95,
        "FSP1": "FSP1: Mobile Money",
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP1: Mobile Money<br>FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 50,
        "ISO2": "MW",
        "Country": "Malawi",
        "CBT_BEN_2014": 153560,
        "CBT_PLAN_BUDGET": 9342565,
        "FSP1": "FSP1: Mobile Money",
        "FSP2": null,
        "FSP3": "FSP3: Mobile money",
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP1: Mobile Money<br>FSP3: Mobile money<br>FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 60,
        "ISO2": "ML",
        "Country": "Mali",
        "CBT_BEN_2014": 253512,
        "CBT_PLAN_BUDGET": 48627398.1,
        "FSP1": null,
        "FSP2": null,
        "FSP3": "FSP3: pre-paid cards",
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP3: pre-paid cards<br>FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 60,
        "ISO2": "MR",
        "Country": "Mauritania",
        "CBT_BEN_2014": 72055,
        "CBT_PLAN_BUDGET": 12801296,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 50,
        "ISO2": "MZ",
        "Country": "Mozambique",
        "CBT_BEN_2014": 59051,
        "CBT_PLAN_BUDGET": 4320333,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": "FSP6: Mobile Money",
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Mobile Money<br>FSP6: Remittance<br>"
      }, {
        "value": 10,
        "ISO2": "MM",
        "Country": "Myanmar",
        "CBT_BEN_2014": 46650,
        "CBT_PLAN_BUDGET": 1073075,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 50,
        "ISO2": "NA",
        "Country": "Namibia",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": null,
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>"
      }, {
        "value": 10,
        "ISO2": "NP",
        "Country": "Nepal",
        "CBT_BEN_2014": 68646,
        "CBT_PLAN_BUDGET": 5660742,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 30,
        "ISO2": "NI",
        "Country": "Nicaragua",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 60,
        "ISO2": "NE",
        "Country": "Niger",
        "CBT_BEN_2014": 366528,
        "CBT_PLAN_BUDGET": 88108876.8,
        "FSP1": "FSP1: Mobile Money",
        "FSP2": null,
        "FSP3": "FSP3: pre-paid cards",
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP1: Mobile Money<br>FSP3: pre-paid cards<br>FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 10,
        "ISO2": "PK",
        "Country": "Pakistan",
        "CBT_BEN_2014": 196698,
        "CBT_PLAN_BUDGET": 14055321.8,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": "FSP5: mobile money; pre-paid cards",
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP5: mobile money; pre-paid cards<br>FSP6: Remittance<br>"
      }, {
        "value": 40,
        "ISO2": "PS",
        "Country": "Palestine ",
        "CBT_BEN_2014": 481631,
        "CBT_PLAN_BUDGET": 38411235,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 30,
        "ISO2": "PY",
        "Country": "Paraguay ",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 927557,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 10,
        "ISO2": "PH",
        "Country": "Philippines",
        "CBT_BEN_2014": 530990,
        "CBT_PLAN_BUDGET": 14381928,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": "FSP5: mobile money; pre-paid cards",
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP5: mobile money; pre-paid cards<br>FSP6: Remittance<br>"
      }, {
        "value": 20,
        "ISO2": "RW",
        "Country": "Rwanda",
        "CBT_BEN_2014": 15948,
        "CBT_PLAN_BUDGET": 3005400,
        "FSP1": "FSP1: Mobile Money",
        "FSP2": null,
        "FSP3": "FSP3: Mobile Money",
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP1: Mobile Money<br>FSP3: Mobile Money<br>FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 60,
        "ISO2": "ST",
        "Country": "S\u00e3o Tom\u00e9 and Principe",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 60,
        "ISO2": "SN",
        "Country": "Senegal",
        "CBT_BEN_2014": 211880,
        "CBT_PLAN_BUDGET": 6998774.02,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 60,
        "ISO2": "SL",
        "Country": "Sierra Leone",
        "CBT_BEN_2014": 1008,
        "CBT_PLAN_BUDGET": 476000,
        "FSP1": "FSP1: Mobile Money",
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP1: Mobile Money<br>FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 20,
        "ISO2": "SO",
        "Country": "Somalia",
        "CBT_BEN_2014": 60108,
        "CBT_PLAN_BUDGET": 19482889,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": null,
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>"
      }, {
        "value": 20,
        "ISO2": "SS",
        "Country": "South Sudan",
        "CBT_BEN_2014": 28770,
        "CBT_PLAN_BUDGET": 29321465.8,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": null,
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>"
      }, {
        "value": 10,
        "ISO2": "LK",
        "Country": "Sri Lanka",
        "CBT_BEN_2014": 62250,
        "CBT_PLAN_BUDGET": 3061013,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": null,
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>"
      }, {
        "value": 40,
        "ISO2": "SD",
        "Country": "Sudan",
        "CBT_BEN_2014": 539396,
        "CBT_PLAN_BUDGET": 40384945,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 50,
        "ISO2": "SZ",
        "Country": "Swaziland",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": null,
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>"
      }, {
        "value": 40,
        "ISO2": "SY",
        "Country": "Syria",
        "CBT_BEN_2014": 2957,
        "CBT_PLAN_BUDGET": 5512144,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": null,
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>"
      }, {
        "value": 40,
        "ISO2": "TJ",
        "Country": "Tajikistan",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": null,
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>"
      }, {
        "value": 50,
        "ISO2": "TZ",
        "Country": "Tanzania, United Republic of",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 47803.42,
        "FSP1": "FSP1: Mobile Money",
        "FSP2": "FSP2: Pre-paid cards",
        "FSP3": "FSP3: Mobile Money",
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": "FSP6: Mobile Money",
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP1: Mobile Money<br>FSP2: Pre-paid cards<br>FSP3: Mobile Money<br>FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Mobile Money<br>FSP6: Remittance<br>"
      }, {
        "value": 10,
        "ISO2": "TL",
        "Country": "Timor-Leste",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": null,
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>"
      }, {
        "value": 60,
        "ISO2": "TG",
        "Country": "Togo",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": "FSP3: Pre-paid Cards",
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP3: Pre-paid Cards<br>FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 40,
        "ISO2": "TN",
        "Country": "Tunisia",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 0,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 40,
        "ISO2": "TR",
        "Country": "Turkey ",
        "CBT_BEN_2014": 219813,
        "CBT_PLAN_BUDGET": 110613859,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 20,
        "ISO2": "UG",
        "Country": "Uganda",
        "CBT_BEN_2014": 6752,
        "CBT_PLAN_BUDGET": 2140109,
        "FSP1": "FSP1: Mobile Money",
        "FSP2": "FSP2: Mobile Money, Pre-paid cards",
        "FSP3": "FSP3: Mobile Money",
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP1: Mobile Money<br>FSP2: Mobile Money, Pre-paid cards<br>FSP3: Mobile Money<br>FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 40,
        "ISO2": "UA",
        "Country": "Ukraine ",
        "CBT_BEN_2014": 9712,
        "CBT_PLAN_BUDGET": 4565000,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 40,
        "ISO2": "YE",
        "Country": "Yemen",
        "CBT_BEN_2014": 547785,
        "CBT_PLAN_BUDGET": 28162285.7,
        "FSP1": null,
        "FSP2": null,
        "FSP3": null,
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }, {
        "value": 50,
        "ISO2": "ZM",
        "Country": "Zambia",
        "CBT_BEN_2014": 0,
        "CBT_PLAN_BUDGET": 890000,
        "FSP1": "FSP1: Mobile Money",
        "FSP2": "FSP2: Pre-paid cards",
        "FSP3": "FSP3: Mobile money, Pre-paid cards.",
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": "FSP5: Mobile Money",
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP1: Mobile Money<br>FSP2: Pre-paid cards<br>FSP3: Mobile money, Pre-paid cards.<br>FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP5: Mobile Money<br>FSP6: Remittance<br>"
      }, {
        "value": 50,
        "ISO2": "ZW",
        "Country": "Zimbabwe",
        "CBT_BEN_2014": 334098,
        "CBT_PLAN_BUDGET": 18390900,
        "FSP1": null,
        "FSP2": "FSP2: Pre-paid cards",
        "FSP3": "FSP3: Pre-paid cards",
        "FSP4": "FSP4: Mobile Money, Pre-paid cards, Remittance",
        "FSP5": null,
        "FSP6": null,
        "FSP7": null,
        "FSP8": "FSP6: Remittance",
        "FSP_Formula": "",
        "FSPs": "FSP2: Pre-paid cards<br>FSP3: Pre-paid cards<br>FSP4: Mobile Money, Pre-paid cards, Remittance<br>FSP6: Remittance<br>"
      }],
      joinBy: ['iso-a2', 'ISO2'],
      mapData: Highcharts.maps['custom/world'],
      maxSize: '2%',
      color: Highcharts.getOptions().colors[1],
      enableMouseTracking: true
    }]
  });

  tl_home = animations.home();
});
